"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _typeof2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.map.js");

var _store = _interopRequireDefault(require("@/store"));

var _props = require("./props");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ElSearchForm',
  props: _props.formProps,
  data: function data() {
    var _this = this;

    var _this$$props = this.$props,
        forms = _this$$props.forms,
        fuzzy = _this$$props.fuzzy;
    var datePrefix = 'daterange-prefix';
    var selectOptionPrefix = 'select-option-prefix';
    var dataObj = {
      selectOptions: {}
    };
    var params = {};
    var format = {};
    var fuzzyOps = {};
    forms.forEach(function (v, i) {
      var propType = (0, _typeof2.default)(v.prop);

      if (propType === 'string') {
        v.modelValue = v.prop;
        params[v.prop] = '';
        fuzzyOps[v.prop] = v.fuzzy ? v.fuzzy : fuzzy;

        if (v.format) {
          format[v.prop] = v.format;
        }
      } else if (propType === 'object' && Object.prototype.toString.call(v.prop) === '[object Array]') {
        // console.log(v.itemType)
        v.prop.forEach(function (vv) {
          params[vv] = '';

          if (v.format) {
            format[vv] = v.format;
          }

          fuzzyOps[vv] = v.fuzzy ? v.fuzzy : fuzzy;
        });
      }

      if (v.itemType === 'daterange' || v.itemType === 'datetimestamp') {
        params[datePrefix + i] = '';
        v.modelValue = datePrefix + i; // console.log(params, v, '000000000000')
      }

      if (v.itemType === 'select' && (v.selectFetch || v.selectUrl)) {
        var dataKey = selectOptionPrefix + i;
        dataObj.selectOptions[dataKey] = [];
        var $axios = _this.$axios;

        if (!v.selectMethod) {
          v.selectMethod = 'get';
        }

        _this.getRemoteData({
          fetch: v.selectFetch ? v.selectFetch : function () {
            return $axios[v.selectMethod](v.selectUrl, v.selectMethod.toLowerCase() === 'get' ? {
              params: v.selectParams
            } : v.selectParams);
          },
          dataKey: dataKey,
          resultField: v.selectResultField || 'data.data',
          resultHandler: v.selectResultHandler,
          extData: v.extData,
          reflect: v.reflect
        });
      } // 设置查询条件中、下拉列表关联的默认查询条件：此处用于机构Id的特殊处理


      if (v.prop == 'clinicId') {
        params[v.prop] = _store.default.getters.organId;
      }
    });
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({
      params: params,
      datePrefix: datePrefix,
      selectOptionPrefix: selectOptionPrefix
    }, dataObj), {}, {
      format: format,
      fuzzyOps: fuzzyOps
    });
  },
  computed: {
    itemStyle: function itemStyle() {
      var itemWidth = this.itemWidth;

      if (itemWidth) {
        return "width: ".concat(itemWidth, "px;");
      }

      return '';
    }
  },
  methods: {
    isArray: function isArray(value) {
      return (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Array]';
    },
    searchHandler: function searchHandler() {
      var _this2 = this;

      // 提交按钮绑定方法
      this.getParams(function (error, params) {
        if (!error) {
          // 表单中传递的查询方法
          var submitHandler = _this2.submitHandler;

          if (submitHandler) {
            submitHandler(params);
          } else {
            throw new Error('必须设置属性: submitHandler !');
          }
        }
      });
    },
    getParamFuzzy: function getParamFuzzy() {
      return this.fuzzyOps;
    },
    getParams: function getParams(callback) {
      var _this3 = this;

      // 提取表单中的prop字段 作为搜索条件字段
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var params = _this3.params,
              datePrefix = _this3.datePrefix,
              format = _this3.format;
          var formattedForm = {};
          Object.keys(params).forEach(function (v) {
            if (v.indexOf(datePrefix) === -1) {
              formattedForm[v] = format[v] ? format[v](params[v], v) : params[v];
            }
          });
          if (callback) callback(null, formattedForm);
        } else {
          if (callback) callback(new Error());
        }
      });
    },
    resetForm: function resetForm() {
      // 重置表单
      this.$refs['form'].resetFields();
      var resetBtnCallback = this.resetBtnCallback;
      if (resetBtnCallback) resetBtnCallback();
      this.searchHandler(); // 请求数据 查询按钮的功能
    },
    changeDate: function changeDate(date, startDate, endDate) {
      // 格式化时间范围选择器组件的数据
      var dates;

      if (date === null) {
        this.params[startDate] = '';
        this.params[endDate] = '';
        this.searchHandler(); // 请求数据 查询按钮的功能

        return;
      }

      if (typeof date === 'string') {
        dates = date.split(' - ');
      } else if (date && date.hasOwnProperty('length')) {
        var firstDate = date[0];
        var secondDate = date[1];
        dates = [firstDate, secondDate]; // dates = [
        //   `${firstDate.getFullYear()}-${('0' + (firstDate.getMonth() + 1)).substr(-2)}-${('0' + firstDate.getDate()).substr(-2)}`,
        //   `${secondDate.getFullYear()}-${('0' + (secondDate.getMonth() + 1)).substr(-2)}-${('0' + secondDate.getDate()).substr(-2)}`
        // ]
      }

      this.params[startDate] = dates[0] / 1000;
      this.params[endDate] = dates[1] / 1000;
      this.searchHandler(); // 请求数据 查询按钮的功能
    },
    getRemoteData: function getRemoteData(_ref) {
      var _this4 = this;

      var fetch = _ref.fetch,
          dataKey = _ref.dataKey,
          resultField = _ref.resultField,
          resultHandler = _ref.resultHandler,
          extData = _ref.extData,
          reflect = _ref.reflect;
      // 获取接口数据做下拉列表
      fetch().then(function (response) {
        var result = response;

        if ((0, _typeof2.default)(response) === 'object' && !_this4.isArray(response)) {
          if (resultField.indexOf('.') !== -1) {
            resultField.split('.').forEach(function (vv) {
              result = result[vv];
            });
          } else {
            result = response[resultField]; // result = response.data
          }
        } // console.log("result-000000", response,result, resultHandler)


        if (!result || !(result instanceof Array)) {
          console.warn("\u63A5\u53E3\u8FD4\u56DE\u7684\u5B57\u6BB5:".concat(resultField, " \u4E0D\u662F\u4E00\u4E2A\u6570\u7EC4"));
        }

        if (extData) {
          for (var i = 0; i < extData.length; i++) {
            result.unshift(extData[i]);
          }
        }

        if (resultHandler) {
          _this4.selectOptions[dataKey] = result.map(resultHandler);
        } else {
          _this4.selectOptions[dataKey] = result;
        }
      });
    }
  }
};
exports.default = _default;